<script lang="ts">
	import type { AvtaleCustomerReviews } from "#lib/types/avtale.js";
	import { PortableText } from "@portabletext/svelte";
	import { t } from "./i18n.svelte";
	import { getContext } from "svelte";
	import { IconStar } from "@ishavskraft/shared";

	interface Props {
		reviews: AvtaleCustomerReviews;
	}

	let { reviews }: Props = $props();
	const getLang = getContext<() => string>("page-lang");
	const i18n = $derived(t(getLang()));

	const formatDate = (date: string): string => {
		return new Date(date).toLocaleDateString(getLang() ?? "nb", {
			day: "2-digit",
			month: "long",
			year: "numeric",
		});
	};
</script>

<div class="mx-edge-x mb-8 tablet:mb-11">
	<h2>{i18n.customerReviewsTitle}</h2>
	<div class="flex flex-col gap-6 tablet:flex-row">
		{#each reviews.reviews as review (review._key)}
			<div class="rounded-xl shadow-md px-2 py-3 flex-1 flex flex-col">
				<!--Rating -->
				<div>
					{#each Array(5) as _, i (i)}
						{#if i < review.stars}
							<IconStar filled class="color-[--lysning]" />
						{:else}
							<IconStar class="color-[--lysning]" />
						{/if}
					{/each}
				</div>
				<!--Text -->
				<div class="mb-5">
					<p class="font-bold">{review.title}</p>
					<PortableText value={review.content} />
				</div>
				<!--date and source -->
				<div class="flex justify-between mt-auto">
					<small>{formatDate(review.reviewDate)}</small>
					<small>
						{#if review.source}
							<a href={review.source}>{review.sourceText}</a>
						{:else}
							{review.sourceText}
						{/if}
					</small>
				</div>
			</div>
		{/each}
	</div>
</div>
